import routes from '@/constants/routes';

import { searchObjectToQueryAdapter } from '@/adapters/search';

export const useGoToSearch = () => {
  const router = useRouter();
  const localeRoute = useLocaleRoute();
  const searchStore = useSearchStore();

  function redirectToSearch({
    filters = searchStore.filters,
    routeId = undefined,
  } = {}) {
    const { departureStation, arrivalStation } = filters;

    if (!departureStation?.id || !arrivalStation?.id)
      return router.push(localeRoute(routes.MAIN));

    searchStore.setSearchLocations({
      [departureStation.id]: departureStation,
      [arrivalStation.id]: arrivalStation,
    });

    return router.push(
      localeRoute({
        name: 'search',
        query: {
          filters: qsStringifyValues(searchObjectToQueryAdapter(filters)),
          selectedRouteId: routeId,
        },
      }),
    );
  }

  return { redirectToSearch };
};
